import React from 'react';
import { Navigate } from 'react-router-dom';

// Helper to decode JWT and check expiration
function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return false; // If no exp, assume not expired
    // exp is in seconds since epoch
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
  } catch (e) {
    return true; // If decode fails, treat as expired
  }
}

const isAuthenticated = () => {
  const token = localStorage.getItem('access_token');
  if (!token) return false;
  if (isTokenExpired(token)) {
    localStorage.removeItem('access_token');
    // Optionally clear other related items
    return false;
  }
  return true;
};

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
